import { render, staticRenderFns } from "./u-textarea-solo-rounded.vue?vue&type=template&id=04c5a8c4&scoped=true"
import script from "./u-textarea-solo-rounded.vue?vue&type=script&lang=js"
export * from "./u-textarea-solo-rounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c5a8c4",
  null
  
)

export default component.exports